import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

const updateActivityTypeActivity = (
  types: ActivityType[],
  id: ActivityType["id"],
  active: boolean
): ActivityType[] => {
  let order = 1;
  return (
    types
      // sorting just to place changed type to end of list to set correct displayOrder to it.
      .sort((t1, t2) => +(t1.id === id) - +(t2.id === id))
      .map((type) => {
        const updatedType =
          type.id === id
            ? {
                ...type,
                active,
              }
            : type;
        if (updatedType.active) {
          updatedType.displayOrder = order;
          order++;
        }
        return updatedType;
      })
  );
};

export default updateActivityTypeActivity;
